var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "navbar navbar-expand-lg navbar-dark",
      attrs: { id: "dashboard-header" }
    },
    [
      _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c("div", [
          _vm.user
            ? _c("p", [
                _vm._v(
                  "\n\t\t\t\tHello " +
                    _vm._s(_vm.user.first_name) +
                    " " +
                    _vm._s(_vm.user.last_name) +
                    "\n\t\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.logout()
                }
              }
            },
            [_vm._v("\n\t\t\t\tLogout\n\t\t\t")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("a", { attrs: { href: "/home/" } }, [
        _c("img", {
          attrs: {
            id: "login-logo",
            src: "/img/login-logo.png",
            alt: "Logo Login"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce6b03b4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce6b03b4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DashboardHeader.vue
// module id = 407
// module chunks = 19